const SEO = [
	{
		page: "home",
		description:
			"I am a web developer studying at NIT Jalandhar and freelancing. Specializing in building scalable, secure, and reliable web applications using various frameworks and technologies.",
		keywords: ["Aryaman Sinha", "Web Developer", "Freelancer", "NIT Jalandhar"],
	},

	{
		page: "about",
		description:
			"I am a web developer studying at NIT Jalandhar and freelancing. Specializing in building scalable, secure, and reliable web applications using various frameworks and technologies.",
		keywords: ["Aryaman Sinha", "Web Developer", "Freelancer", "NIT Jalandhar"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Aryaman Sinha", "Web Developer", "Freelancer", "NIT Jalandhar"],
	},

	{
		page: "projects",
		description:
			"",
		keywords: ["Aryaman Sinha", "Web Developer", "Freelancer", "NIT Jalandhar"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Aryaman Sinha", "Web Developer", "Freelancer", "NIT Jalandhar"],
	},
];

export default SEO;
